module.exports = __webpack_public_path__ + "img/partner3.b4ef5bb0.png";